/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBullhornS = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M22 20.517V1.483L6.795 8H2v6h3v3c0 .827.24 2.044.988 3.084C6.774 21.175 8.074 22 10 22c.827 0 2.045-.24 3.084-.988.992-.715 1.764-1.855 1.896-3.504zM7 17v-2.912l6 2.571V17c0 1.275-.508 1.975-1.084 2.39-.627.45-1.41.61-1.916.61-1.274 0-1.974-.507-2.388-1.083C7.16 18.289 7 17.506 7 17z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgBullhornS as BullhornS };
